import { render } from "./ModalWithdrawOtonAcept.vue?vue&type=template&id=4d2d6568&scoped=true&ts=true"
import script from "./ModalWithdrawOtonAcept.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawOtonAcept.vue?vue&type=script&lang=ts"

import "./ModalWithdrawOtonAcept.vue?vue&type=style&index=0&id=4d2d6568&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2d6568"]])

export default __exports__